/** 칩 라벨 요약 — 없으면 이름표, 1개면 그 이름, 여러 개면 "보철과 외 1" */
export const summarizeSelection = (names: string[], placeholder: string): string => {
    if (names.length === 0) return placeholder;
    if (names.length === 1) return names[0];
    return `${names[0]} 외 ${names.length - 1}`;
};
